<template>
  <div class="container">
    <a-divider type="horizontal" class="divider" />

    <a-popover
      v-model:visible="visible"
      :title="null"
      placement="right"
      overlayClassName="form-input__popover"
    >
      <template #content>
        <a-tooltip title="Agregar elemento" placement="right">
          <a-button class="button" type="link" @click="handleAdd">
            <PlusOutlined class="button__icon" />
          </a-button>
        </a-tooltip>

        <a-tooltip
          :title="disabledSettings ? 'Elemento no configurable' : 'Editar elemento'"
          placement="right"
        >
          <a-button class="button" type="link" :disabled="disabledSettings" @click="handleSettings">
            <SettingOutlined class="button__icon" />
          </a-button>
        </a-tooltip>

        <a-tooltip title="Duplicar elemento" placement="right">
          <a-button class="button" type="link" @click="handleCopy">
            <CopyOutlined class="button__icon" />
          </a-button>
        </a-tooltip>

        <a-tooltip title="Eliminar elemento" placement="right">
          <a-button class="button" type="link" @click="handleDelete">
            <DeleteOutlined class="button__icon" />
          </a-button>
        </a-tooltip>
      </template>

      <div class="card" :class="{ select: selected }">
        <div id="drag-zone">
          <MoreOutlined class="drag__icon" />
          <MoreOutlined class="drag__icon" />
        </div>

        <div class="input">
          <FormInput :input="input" />
        </div>
      </div>
    </a-popover>
  </div>
</template>

<script setup lang="ts">
import { ref, inject, watch, nextTick, computed } from "vue";
import type { Ref } from "vue";
import {
  MoreOutlined,
  PlusOutlined,
  SettingOutlined,
  CopyOutlined,
  DeleteOutlined,
} from "@ant-design/icons-vue";

import { ElementType, FormElement } from "@/@types/entities/forms";

import FormInput from "@/app/entities/components/sections/forms/FormInput.vue";

const props = defineProps<{
  input: FormElement;
  selected: boolean;
}>();

const emit = defineEmits<{
  (e: "select", input: FormElement | undefined): void;
  (e: "click:add", input: FormElement): void;
  (e: "click:settings", input: FormElement): void;
  (e: "click:copy", input: FormElement): void;
  (e: "click:delete", input: FormElement): void;
}>();

const visible = ref(false);

const selectedInput = inject("selectedInput") as Ref<FormElement | undefined>;

const disabledSettings = computed(() =>
  [ElementType.Pdp, ElementType.Reminder].includes(props.input.type)
);

// watch(visible, (isVisible) => {
//   const keepSelect = currentAction.value === "add" || currentAction.value === "settings";

//   if (isVisible) selectedInput.value = props.input;
//   else if (!keepSelect) selectedInput.value = undefined;
// });
watch(visible, (isPopoverVisible) => {
  handleSelect(isPopoverVisible ? props.input : undefined);
});

const handleSelect = (element: FormElement | undefined) => {
  selectedInput.value = element;
};

const handleAdd = async () => {
  visible.value = false;
  emit("click:add", props.input);
  await nextTick();
  handleSelect(props.input);
};

const handleSettings = async () => {
  visible.value = false;
  emit("click:settings", props.input);
  await nextTick();
  handleSelect(props.input);
};

const handleCopy = () => {
  visible.value = false;
  emit("click:copy", props.input);
};

const handleDelete = async () => {
  visible.value = false;
  await nextTick();
  emit("click:delete", props.input);
  handleSelect(undefined);
};
</script>

<style scoped lang="sass">
.divider
  margin: 0
  color: $gray-4

.container
  background-color: white

.card
  padding: 24px 18px
  display: flex
  align-items: center
  gap: 20px
  border: 1px dashed transparent
  border-radius: 4px
  cursor: pointer
  transition: border-color 0.2s ease-out

  &:hover
    border-color: $blue-6

  &.select
    border-color: $blue-6

.input
  width: 100%
  pointer-events: none

.drag__icon
  font-size: 20px
  color: $gray-1

  &:last-child
    margin-left: -26px

.button
  padding: 0

  &__icon
    font-size: 16px
</style>

<style>
.form-input__popover .ant-popover-arrow {
  display: none;
}

.form-input__popover .ant-popover-content,
.form-input__popover .ant-popover-inner {
  border-radius: 4px;
  padding: 0;
}

.form-input__popover .ant-popover-inner-content {
  padding: 6px 10px !important;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
</style>
